import {
    GetFolderIdsDataType,
    CalendarIdsGetFolderIdsData,
    GetFolderIdsData,
} from '../store/schema/GetFolderIdsData';
import { assertNever } from 'owa-assert';
import {
    getUpdatedFolderIds,
    getDefaultCalendar,
    getCalendarFolderId,
} from '../selectors/calendarCacheSelectors';

export function getFolderIds(value: GetFolderIdsData): string[] {
    const valueType = value.loaderType;
    switch (valueType) {
        case GetFolderIdsDataType.CalendarIds:
            return getUpdatedFolderIds((value as CalendarIdsGetFolderIdsData).calendarIds);
        case GetFolderIdsDataType.DefaultCalendar:
            return [getCalendarFolderId(getDefaultCalendar())];
        default:
            return assertNever(valueType);
    }
}
